<script setup lang="ts">
import ProductCatalog from "~/components/products/ProductCatalog.vue";

const route = useRoute();
const brandSlug = computed(() => String(route.params.brand_slug));
</script>

<template>
  <ProductCatalog :key="brandSlug" :brand-slug="brandSlug" />
</template>
